<template lang="html">
<section id="faq" v-if="home[currentLang].faq.length">
	<div class="content">
		<header class="hidden"><h1>{{ $t('faq') }}</h1></header>
		<section 
		:id="'question'+index" 
		:class="toggleClasses('dropdown dropdown--dark', 'question'+index)"  
		v-for="(question, index) in home[currentLang].faq" 
		:key="'question'+index">
			<header class="dropdown-header" @click="showToggle('question'+index);">
				<h1 class="small-header">{{ question.label }}</h1>
				<span class="dropdown-button"></span>
			</header>
			<transition name="slide">
				<div class="dropdown-content" v-if="show.includes('question'+index)">
					<p>{{ question.description }}</p>
				</div>
			</transition>
		</section>
	</div>
</section>
</template>

<script>

import dropdownHandler  from '@/mixins/dropdownHandler.js'

export default {
	mixins: [dropdownHandler],
	props: ['home', 'isLandingMounted', 'currentLang'],
}
</script>

<style lang="scss" scoped>
#app #faq{
	background-color: var(--bgcolor);
	padding-top: 6rem;
    padding-bottom: 5rem;
	@media screen and (max-width:1024px){
		padding:2rem;
	}
	.content{
		max-width:800px;
		margin:auto;
		padding:0;
	}
	.dropdown{
		margin-bottom: .8rem;
		border-bottom: 1px solid #333;
		@media screen and (min-width:768px) { 
			margin-bottom: 2rem;
		}
		&:last-child{
			border:none;
		}
		.dropdown-header {
			margin-bottom:0;
			padding: .7rem 0 1.2rem 0;
			@media screen and (min-width:768px) {
				padding: .7rem 0;
			}
			h1.small-header {
				font-size: 1.333rem;
				@media screen and (min-width:1024px){
					font-size: 1.4rem;
				}
				@media screen and (max-width:1024px){
					line-height: 1.8rem;
					max-width: 85%;
				}
			}
		}
		.dropdown-content{
			max-width: 85%;
		}
	}
}
</style>
